function a(a,e,f,i){a._m(e),a.o(e,"BasePageTemplate",()=>a.f(m));var m=a.i(f("74785812"));}